import React from 'react'

const geoData = [
  { Name: '安和門市', Tags: '7-11@六張犁', Latitude: 25.022312288075184, Longitude: 121.5545948348868, Radius: 25 },
  { Name: '崇德門市', Tags: '7-11@六張犁', Latitude: 25.02427608829106, Longitude: 121.55562480304577, Radius: 25 },
  { Name: '安居門市', Tags: '7-11@六張犁', Latitude: 25.020790069826855, Longitude: 121.55431551121347, Radius: 25 }
]

const addressData = [
  { Name: '安和門市', Tags: '7-11@六張犁', Address: '106台北市大安區和平東路三段230號', Radius: 25 },
  { Name: '崇德門市', Tags: '7-11@六張犁', Address: '110台北市信義區崇德街104號', Radius: 25 },
  { Name: '安居門市', Tags: '7-11@六張犁', Address: '106台北市大安區安居街33號', Radius: 25 }
]

const data = { geo: geoData, address: addressData }

function UploadExample (props) {
  const { type, columns } = props
  return (
    !type
      ? ''
      : <table border="1">
          <thead>
            <tr>{columns[type].map(i => <th key={i}>{i}</th>)}</tr>
          </thead>
          <tbody>
            {data[type].map((item, idx) => (
              <tr key={idx}>
                {columns[type].map((th, idx2) => <td key={`${idx2}_${idx}`}>{item[th]}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
  )
}

export default UploadExample
